import { StatsigSynchronousProvider } from '@eventbrite/statsig';
import { connectStatsigProvider } from './connectStatsigProvider';

export const ConnectedStatsigSynchronousProvider = connectStatsigProvider(
    StatsigSynchronousProvider,
);
